import axios from "@/plugins/axios";

let url = "/api/plugins/wpay";

export const wpay = {
    /**
     * 결제 시작 — 회원 진행 상태에 맞는 첫 화면(회원가입/계좌등록/결제인증) 폼을 받는다.
     * 응답 { checkout: { url, params } } 을 자동제출 폼으로 이니시스 결제창(새창)에 전송한다.
     * @param {{ orderNo: string, ci: string }} data
     * @returns {Promise<{ success: boolean, checkout: { url: string, params: object } }>}
     */
    request(data) {
        return axios.post(`${url}/request`, data).then((result) => result.data);
    },
};
